<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="/">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>企业管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 主体内容 -->
    <div class="content">
      <el-form inline label-position="right" label-width="60px" size="small" class="query-form">
        <el-form-item label="搜索">
          <el-input v-model="key" placeholder="请输入关键词"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="selList();">查询</el-button>
          <el-button type="success" @click="dialogVisible=true;form={isEnable:true};">新增</el-button>
        </el-form-item>
      </el-form>
      <!-- 列表查询 -->
      <el-card class="box-card table">
        <div slot="header" class="clearfix">
          <span>企业记录列表</span>
        </div>
        <!-- 列表定义 -->
        <el-table
          v-loading="loading"
          :data="tableData"
          ref="tableData"
          border
          stripe
          style="width:100%;"
        >
          <el-table-column prop="shortName" label="企业简称"></el-table-column>
          <el-table-column prop="fullName" label="企业全称"></el-table-column>
          <el-table-column prop="legal" label="法人"></el-table-column>
          <el-table-column prop="mobile" label="联系电话"></el-table-column>
          <el-table-column prop="wechat" label="联系微信"></el-table-column>
          <el-table-column prop="site" label="地址"></el-table-column>
          <el-table-column label="官网">
            <template slot-scope="scope">
              <a :href="scope.row.webSite" target="_blank">{{scope.row.webSite}}</a>
            </template>
          </el-table-column>
          <el-table-column prop="stateName" label="合作状态"></el-table-column>

          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-tooltip content="编辑" placement="top">
                <el-button
                  type="primary"
                  size="mini"
                  icon="el-icon-edit"
                  @click="editClick(scope.row)"
                ></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页条 -->
        <div class="block" style="margin-top:20px;">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage4"
            :page-sizes="[10, 20, 30, 50,100]"
            :page-size="pageSize"
            layout="total, sizes,prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </el-card>
    </div>

    <!-- 操作对话框 -->
    <el-dialog :title="form.id>0?'编辑企业信息':'添加企业信息'" :visible.sync="dialogVisible">
      <el-form
        :model="form"
        ref="form"
        label-width="100px"
        :status-icon="true"
        @submit.native.prevent="submitForm('form')"
      >
        <el-form-item
          label="企业简称"
          prop="shortName"
          :rules="[
        {required:true,message:'请输入企业简称'}
        ]"
        >
          <el-input v-model="form.shortName" placeholder="请输入企业简称"></el-input>
        </el-form-item>
        <el-form-item
          label="企业全称"
          prop="fullName"
          :rules="[
       {required:true,message:'请输入企业全称'}
        ]"
        >
          <el-input v-model="form.fullName" placeholder="请输入企业全称"></el-input>
        </el-form-item>
        <el-form-item label="法人" prop="legal">
          <el-input v-model.number="form.legal"></el-input>
        </el-form-item>
        <el-form-item label="电话" prop="mobile">
          <el-input v-model.number="form.mobile"></el-input>
        </el-form-item>
        <el-form-item label="微信" prop="wechat">
          <el-input v-model="form.wechat"></el-input>
        </el-form-item>
        <el-form-item label="地址" prop="site">
          <el-input v-model="form.site"></el-input>
        </el-form-item>
        <el-form-item label="官网" prop="webSite">
          <el-input v-model="form.webSite"></el-input>
        </el-form-item>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="合作状态" prop="state" :rules="[{required:true,message:'请选择分类'}]">
              <el-select v-model="form.state" filterable>
                <el-option
                  v-for="item in stateList"
                  :label="item.name"
                  :value="item.id"
                  :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
          <el-form-item label="是否自营公司" prop="isSelf">
                <el-switch
                v-model="form.isSelf"
                active-color="#13ce66"
                inactive-color="#ff4949">
              </el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="经度" prop="latitude" :rules="[{required:false,message:'请填写经度'}]">
          <el-input v-model.number="form.latitude" ></el-input>
        </el-form-item>
        <el-form-item label="纬度" prop="longitude" :rules="[{required:false,message:'请填写经度'}]">
          <el-input v-model.number="form.longitude"></el-input>
        </el-form-item>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item>
              <el-button type="success" @click=" dialogMap = true" >选择坐标</el-button>
            </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="上下班时间">
                <template>
                  <el-time-select
                    placeholder="起始时间"
                    v-model="form.workStart"
                    :picker-options="{
                      start: '08:30',
                      step: '00:15',
                      end: '18:30'
                    }">
                  </el-time-select>
                  <el-time-select
                    placeholder="结束时间"
                    v-model="form.workEnd"
                    :picker-options="{
                      start: '08:30',
                      step: '00:15',
                      end: '18:30',
                      minTime: form.workStart
                    }">
                  </el-time-select>
                </template>
               </el-form-item>
            </el-col>
        </el-row>
    
        <el-form-item>
          <el-button type="primary" :loading="submiting" native-type="submit">提交</el-button>
          <el-button @click="dialogVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
       <!-- 地图表单 -->
       <el-form label-width="100px">
      <el-dialog title="地址选择"  :visible.sync="dialogMap" @opened="dialogMapOpen()">
        <el-form-item label="搜索地址：">
          <el-input v-model="searchKey">
            <template #append>
              <el-button type="primary" @click="searchMap()">
                <el-icon>
                  <Search />
                </el-icon>
                搜索</el-button
              >
            </template>
          </el-input>
        </el-form-item>
        <div id="mapContainer" style="height: 500px"></div>
        <template #footer>
          <el-button type="success" @click="yesClickMap">确定</el-button>
          <el-button @click="dialogMap = false">取消</el-button>
        </template>
       
      </el-dialog>
    </el-form>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";
export default {
  data() {
    return {
      key:'',
      query: {}, //对象
      loading: false,
      currentPage4: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      form: {}, //表单对象
      dialogVisible: false,
      submiting: false,
      dialogMap: false,//地图表单控制
      id: 0,
      searchKey:"",
      stateList: [
        {
          id: 1,
          name: "合作中"
        },
        {
          id: 2,
          name: "待合作"
        },
        {
          id: 10,
          name: "已终止"
        }
      ]
    };
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage4 = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage4 = val;
      this.getList();
    },
    //筛选
    filterTag(filter) {
      var val = filter["isEnable"][0];
      this.form.isEnable = val;
      //刷新列表
      this.getList();
    },
    //排序
    sortChange(sortColumn) {
      this.form.sort = sortColumn.prop;
      this.form.order = sortColumn.order;
      //刷新列表
      this.getList();
    },
         //地图框显示
         dialogMapOpen() {
      var _this = this;
      // 选择坐标处理
      var map;
      var marker;
      var citylocation;
      var init = function () {
        var center = new qq.maps.LatLng(39.916527, 116.397128);
        map = new qq.maps.Map(document.getElementById("mapContainer"), {
          center: center,
          zoom: 13,
        });
        //获取城市列表接口设置中心点
        citylocation = new qq.maps.CityService({
          complete: function (result) {
            var startLatLng = result.detail.latLng;
            if (_this.form.latitude) {
              startLatLng = new qq.maps.LatLng(
                _this.form.latitude,
                _this.form.longitude
              );
            }
            map.setCenter(startLatLng);
            _this.latLng = startLatLng;

            //添加标记
            marker = new qq.maps.Marker({
              position: startLatLng,
              draggable: true,
              map: map,
            });
            _this.marker = marker;
            //添加到提示窗
            var info = new qq.maps.InfoWindow({
              map: map,
            });
            qq.maps.event.addListener(marker, "mouseup", function (e) {
              //获取经纬度 e.latLng
              //获取坐标 e.cursorPixel
              info.open();
              info.setContent(
                '<div style="text-align:center;white-space:nowrap;' +
                  'margin:10px;">坐标：' +
                  e.latLng.lat +
                  "," +
                  e.latLng.lng +
                  "</div>"
              );
              info.setPosition(e.latLng);

              _this.latLng = e.latLng;
            });
          },
        });
        //调用searchLocalCity();方法    根据用户IP查询城市信息。
        citylocation.searchLocalCity();

        //处理搜索逻辑
        _this.map = map;
        _this.searchKey = _this.form.siteDetail;
        if (!_this.form.latitude && _this.searchKey) {
          setTimeout(() => {
            _this.searchMap();
          }, 500);
        }
      };
      init();
    },
    //确定按钮
    yesClickMap() {
      this.form.latitude = this.latLng.lat;
      this.form.longitude = this.latLng.lng;
      this.dialogMap = false;
    },
    //搜索按钮
    searchMap() {
      var _this = this;
      //执行搜索操作
      var searchService = new qq.maps.SearchService({
        complete: function (results) {
          var res = results.detail;
          if (res.pois && res.pois.length > 0) {
            var latLng = res.pois[0].latLng;
            _this.map.setCenter(latLng);
            _this.marker.setPosition(latLng);
          }
        },
      });
      searchService.search(this.searchKey);
    },
    getList: function() {
      var _this = this;
      _this.loading = true;
      var params = _this.query;
      params.pageindex = _this.currentPage4;
      params.pagesize = _this.pageSize;
      params.key=_this.key;
      var link = url.getAccInfo("getlist_commany");
      $.get(link, params, data => {
        _this.loading = false;
        _this.tableData = data.list;
        _this.total = data.total;
      });
    },
    //搜索查询
    selList:function(){
      this.currentPage4=1;
      this.getList();
    },
    //提交表单
    submitForm(formName) {
      var _this = this;
      var link = url.getAccInfo("addorupdate_commany");
      var info = this.form;
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submiting = true;
          //提交后台添加
          //添加或者修改
          $.post(link, info, res => {
            _this.submiting = false;
            if (res.status) {
              _this.dialogVisible = false;
              _this.getList();
              _this.$message({
                type: "success",
                message: res.msg
              });
            } else {
              _this.$message({
                type: "error",
                message: res.msg
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    //编辑
    editClick: function(row) {
      this.form = Object.assign({}, row);
      this.dialogVisible = true;
    }
  },
  created() {
    //获取列表
    this.getList();
  }
};
</script>

<style>
.query-form {
  margin-top: 20px;
  padding-top: 25px;
  background: #f2f2f2;
}
</style>


